module.exports = __webpack_public_path__ + "static/media/edit.1f949fe2.svg";